module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xBC3S4/html/docimages/cover_ader.jpg?1684274499700",
      "alt": "This image is the cover for the book Seven Words of Jesus and Mary"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Seven Words of Jesus and Mary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Fulton J. Sheen turned his voice and pen to many subjects during the course of a long and remarkable apostolate. But nothing was closer to the heart of his message than bringing the words of Our Lord and Our Blessed Mother to bear on the problems of modern life and the modern world. In this book, Archbishop Sheen explores the connection between the seven words spoken by Mary in the Gospels, and the seven last words of Jesus on the Cross. Fulton Sheen was unparalleled in his ability to combine theology, devotion, and the profoundest reflections on the central events of the Christian narrative. Displayed here in full are the literary and rhetorical skills of one of the greatest preachers of the 20th century. Sheen’s meditations will slake the spiritual thirst of all who desire a fuller understanding of the Gospels and seek to draw closer to Christ and Mary.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fulton J. Sheen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Fulton J. Sheen (1895-1979) was one of the best-loved prelates of twentieth century Catholicism. A prolific writer and orator, a distinguished scholar and teacher, an influential master of the media, Bishop Sheen was one of the most effective communicators of our time. His scores of books have offered inspiration, profound thought, and penetrating analysis of Christian faith and life.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Angelico Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0